<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33">
                <stats-card data-background-color="orange">
                    <template slot="header">
                        <md-icon>access_time</md-icon>
                    </template>

                    <template slot="content">
                        <p class="category">Total hours</p>
                        <h3 class="title">{{ toHours(totalHours) }}</h3>
                    </template>
                </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33">
                <stats-card data-background-color="red">
                    <template slot="header">
                        <md-icon>attach_money</md-icon>
                    </template>

                    <template slot="content">
                        <p class="category">Billable hours</p>
                        <h3 class="title">{{ toHours(billableHours) }}</h3>
                    </template>
                </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-33 md-xsmall-size-100 md-size-33">
                <stats-card data-background-color="blue">
                    <template slot="header">
                        <md-icon>grade</md-icon>
                    </template>

                    <template slot="content">
                        <p class="category">Productivity score</p>
                        <h3 class="title">{{ format((billableHours / totalHours) * 100) }}%</h3>
                    </template>
                </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
                <chart-card :chart-data="supportChart.data" :chart-options="supportChart.options" chart-type="Line" data-background-color="blue">
                    <template slot="content">
                        <h4 class="title">Support hours ({{ toHours(totalSupportHours) }})</h4>
                        <p class="category">for this month</p>
                    </template>

                    <template slot="footer">
                        <div class="stats">
                            <md-icon>access_time</md-icon>
                            updated 1 hour ago
                        </div>
                    </template>
                </chart-card>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
                <chart-card :chart-data="projectChart.data" :chart-options="projectChart.options" :chart-type="'Line'" data-background-color="red">
                    <template slot="content">
                        <h4 class="title">Project hours ({{ toHours(totalProjectHours) }})</h4>
                        <p class="category">for this month</p>
                    </template>

                    <template slot="footer">
                        <div class="stats">
                            <md-icon>access_time</md-icon>
                            updated 1 hours ago
                        </div>
                    </template>
                </chart-card>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header data-background-color="primary">
                        <div class="flex-container">
                            <h4 class="title">Projects</h4>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <md-table table-header-color="primary">
                            <md-table-row>
                                <md-table-head>Name</md-table-head>
                                <md-table-head>Hours</md-table-head>
                            </md-table-row>
                            <md-table-row v-for="project in recentProjects" v-bind:key="project.name">
                                <md-table-cell>{{ project.name }}</md-table-cell>
                                <md-table-cell>{{ toHours(project.total) }}</md-table-cell>
                            </md-table-row>
                        </md-table>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "@/axios";
import utils from "@/utils.js";
import { StatsCard, ChartCard, NavTabsCard, NavTabsTable, OrderedTable } from "@/components";

export default {
    mixins: [utils],
    components: {
        StatsCard,
        ChartCard,
        NavTabsCard,
        NavTabsTable,
        OrderedTable
    },
    data() {
        return {
            totalSupportHours: 0,
            totalProjectHours: 0,
            totalHours: 0,
            billableHours: 0,
            recentProjects: [],
            supportChart: {
                data: {
                    labels: ["M", "T", "W", "T", "F", "S", "S"],
                    series: []
                },
                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 0
                    }),
                    low: 0,
                    high: 10, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                    chartPadding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }
                }
            },
            projectChart: {
                data: {
                    labels: ["M", "T", "W", "T", "F", "S", "S"],
                    series: []
                },
                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 0
                    }),
                    low: 0,
                    high: 10, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                    chartPadding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }
                }
            },
            dataCompletedTasksChart: {
                data: {
                    labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
                    series: [[230, 750, 450, 300, 280, 240, 200, 190]]
                },

                options: {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 0
                    }),
                    low: 0,
                    high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                    chartPadding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }
                }
            },
            emailsSubscriptionChart: {
                data: {
                    labels: ["Ja", "Fe", "Ma", "Ap", "Mai", "Ju", "Jul", "Au", "Se", "Oc", "No", "De" ],
                    series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
                },
                options: {
                    axisX: {
                        showGrid: false
                    },
                    low: 0,
                    high: 1000,
                    chartPadding: {
                        top: 0,
                        right: 5,
                        bottom: 0,
                        left: 0
                    }
                },
                responsiveOptions: [
                    [
                        "screen and (max-width: 640px)",
                        {
                        seriesBarDistance: 5,
                            axisX: {
                                labelInterpolationFnc: function(value) {
                                    return value[0];
                                }
                            }
                        }
                    ]
                ]
            }
        };
    },
    methods: {
        fetch() {
            axios.get('/dashboard')
                .then(response => {
                    this.supportChart.data.series = [response.data.support.series];
                    this.supportChart.data.labels = response.data.support.labels;
                    this.projectChart.data.series = [response.data.project.series];
                    this.projectChart.data.labels = response.data.project.labels;
                    this.totalSupportHours = response.data.support.total;
                    this.totalProjectHours = response.data.project.total;
                    this.billableHours = response.data.cardInfo.billable;
                    this.totalHours = response.data.cardInfo.total;
                    this.recentProjects = response.data.recentProjects;
                })
        }
    },
    mounted() {
        this.fetch();
    }
};
</script>
